<template>
  <vs-col
    vs-offset="0.2"
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="flex-start"
    vs-w="8.8"
    vs-sm="12"
  >
    <vs-row
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="flex-start"
      vs-w="12"
    >
      <vs-card class="cstm_vx_card">
        <div slot="header">
          <vs-row
            style="margin-top: -8px"
            vs-type="flex"
            vs-justify="space-between"
          >
            <vs-col
              v-if="buttonHideCopy === false"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="0.5"
            >
              <vs-button
                @click="back"
                icon-pack="feather"
                icon="icon-arrow-left"
                type="line"
              ></vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="11.3"
            >
              <h4>{{ testrepoPathCopy }}</h4>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="5.5"
            >
              <createsubfolder
                :repo_id="testrepoIdCopy"
                :repo_path="testrepoPathCopy"
                @addedSubFolder="addedSubFolder($event)"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="5.5"
            >
              <fileupload
                :repo_id="testrepoIdCopy"
                :repo_path="testrepoPathCopy"
                @addedFile="addedFile($event)"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="0.5"
            >
              <vs-tooltip text="Delete" position="bottom">
                <vs-button
                  type="flat"
                  v-if="this.files.length > 1 && checkDeletePermission()"
                  icon-pack="feather"
                  @click="allDelete()"
                  color="danger"
                  icon="icon-trash-2"
                ></vs-button>
                <span></span>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </div>
        <div>
          <vs-row vs-justify="center" vs-align="center">
            <vs-row type="flex" vs-justify="center"> </vs-row>
            <br />
            <br />

            <vs-col
              vs-offset="0.1"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3.9"
              vs-sm="12"
              :key="index.id"
              v-for="(item, index) in allFileCopy.file1"
            >
              <vs-card actionable class="cardx cstm-cardx">
                <!-- <div slot="media">
                  <a :href="item.file_path" ><img class="cstm-card-img" :src="item.file_path"/></a>
                </div> -->
                <div
                  slot="media"
                  v-if="
                    item.file_type === 'image/jpeg' ||
                    item.file_type === 'image/png'
                  "
                >
                  <a :href="item.file_path"
                    ><img class="cstm-card-img" :src="item.file_path"
                  /></a>
                </div>
                <div slot="media" v-else-if="item.file_type === 'video/mp4'">
                  <a :href="item.file_path"
                    ><video class="cstm-card-img" :src="item.file_path"></video
                  ></a>
                </div>
                <div slot="media" v-else-if="item.file_type === 'audio/mpeg'">
                  <a :href="item.file_path"
                    ><img
                      class="cstm-card-img"
                      src="@/assets/images/elements/audio.png"
                  /></a>
                </div>
                <div
                  slot="media"
                  v-else-if="item.file_type === 'application/pdf'"
                >
                  <a :href="item.file_path"
                    ><img
                      class="cstm-card-img"
                      height="80px"
                      width="80px"
                      src="@/assets/images/elements/doc.png"
                  /></a>
                </div>
                <div slot="media" v-else>
                  <a :href="item.file_path"
                    ><img
                      class="cstm-card-img"
                      src="@/assets/images/elements/doc.png"
                  /></a>
                </div>
                <div>
                  <vs-row vs-type="flex" vs-justify="space-between">
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="flex-start"
                      vs-w="11.1"
                    >
                      <a class="break-all" :href="item.file_path"
                        ><span class="cstm-file-name">{{
                          item.file_name
                        }}</span></a
                      >
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="flex-start"
                      vs-w="0.8"
                      v-if="checkEditPermission()"
                    >
                      <vs-tooltip text="Edit" position="bottom">
                        <vs-icon
                          @click="editPopup(item)"
                          icon-pack="feather"
                          color="primary"
                          icon="icon-edit"
                        ></vs-icon>
                        <span></span>
                      </vs-tooltip>
                    </vs-col>
                  </vs-row>

                  <span>{{ item.size / 1000 }}</span
                  ><span>KB</span>
                </div>

                <div>
                  <vs-row class="flex-no-wrap" vs-justify="flex-end">
                    <input
                      type="checkbox"
                      class="checkboxStyle"
                      v-model="checkBox1[index]"
                      :value="item.files_id"
                      @click="check($event)"
                      v-if="checkDeletePermission()"
                    />

                    <vs-tooltip text="Details" position="bottom">
                      <vs-button
                        type="flat"
                        @click="detailsPopup(item)"
                        icon-pack="feather"
                        color="dark"
                        icon="icon-eye"
                      ></vs-button>
                      <span></span>
                    </vs-tooltip>

                    <vs-tooltip text="Download" position="bottom">
                      <vs-button
                        color="success"
                        type="flat"
                        @click="downloadImage(item)"
                        icon-pack="feather"
                        icon="icon-download"
                      ></vs-button>
                      <span></span>
                    </vs-tooltip>
                    <vs-tooltip v-if="checkDeletePermission()" text="Delete" position="bottom">
                      <vs-button
                        type="flat"
                        icon-pack="feather"
                        @click="fileDelete(item.files_id)"
                        color="danger"
                        icon="icon-trash-2"
                      ></vs-button>
                      <span></span>
                    </vs-tooltip>
                  </vs-row>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-row vs-justify="center" vs-align="center">
            <vs-row type="flex" vs-justify="center"> </vs-row>
            <br />
            <br />

            <vs-col
              vs-offset="0.3"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3.7"
              vs-xs="12"
              :key="index.id"
              v-for="(item, index) in allFileCopy.file2"
            >
              <vs-card class="cstm_vx_card_1">
                <div slot="header">
                  <vs-row vs-type="flex" vs-justify="space-between">
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="center"
                      vs-w="10"
                    >
                      <span>
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-folder"
                        ></vs-icon> </span
                      >&nbsp;
                      <p @click="openFolder(item)" class="pStyle">
                        &nbsp;{{ item.repository_name }}
                      </p>
                      <!-- <router-link :to="{name: 'folder', params: { repo_id: item.repository_id, repo_path: item.repository_path }}">{{item.repository_name}}</router-link> -->
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="center"
                      vs-w="1.5"
                      v-if="checkDeletePermission()"
                    >
                      <vs-tooltip text="Delete" position="bottom">
                        <vs-button
                          type="flat"
                          icon-pack="feather"
                          @click="folderDelete(item.repository_id)"
                          color="danger"
                          icon="icon-trash-2"
                        ></vs-button>
                        <span></span>
                      </vs-tooltip>
                    </vs-col>
                  </vs-row>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
          <br />
          <br />
        </div>
        <div slot="footer"></div>
      </vs-card>

      <vs-popup title="Delete Folder" :active.sync="deletepopupflag">
        <vs-row>
          <span>Are you sure to delete this Folder?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="folderDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag = !deletepopupflag" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup title="Delete File" :active.sync="deletepopupflag1">
        <vs-row>
          <span>Are you sure to delete this file?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="fileDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag1 = !deletepopupflag1" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup title="Delete Selected Files" :active.sync="deletepopupflag2">
        <vs-row>
          <span>Are you sure to delete selected files ?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="allDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag2 = !deletepopupflag2" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Update File Name"
        :active.sync="popupEdit"
      >
        <vs-input
          placeholder="File Name"
          v-model="fileRenameDetails.file_name"
          class="mt-5 w-full"
        />
        <vs-button
          class="mt-5 w-full"
          :disabled="buttonActive"
          @click="updateFileName"
          color="primary"
          type="filled"
          >Update</vs-button
        >
      </vs-popup>

      <vs-popup
        classContent="popup-ex"
        :title="details.file_name"
        :active.sync="popupDetails"
      >
        <!-- <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5.5">
            <p style="cursor: pointer;" @click="sharingTab=false">Details</p>
            
          </vs-col> -->

        <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5.5">
            <p style="cursor: pointer;" v-if="switch1===true" @click="sharingTab=true">Sharing Settings</p>
            
          </vs-col> -->

        <!-- </vs-row> -->
        <!-- <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5.5">
             <vs-divider v-if="sharingTab===false" border-style="dotted" color="primary"></vs-divider>
            
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5.5">
             <vs-divider v-if="sharingTab===true" border-style="dotted" color="primary"></vs-divider>
            
          </vs-col>
         
        </vs-row> -->
        <div v-if="sharingTab === false">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div
                v-if="
                  details.file_type === 'image/jpeg' ||
                  details.file_type === 'image/png'
                "
              >
                <img
                  class="cstm-card-img"
                  height="80px"
                  width="80px"
                  :src="details.file_path"
                />
              </div>
              <div v-else-if="details.file_type === 'video/mp4'">
                <video
                  class="cstm-card-img"
                  height="80px"
                  width="80px"
                  :src="details.file_path"
                ></video>
              </div>
              <div v-else-if="details.file_type === 'audio/mpeg'">
                <img
                  class="cstm-card-img"
                  height="80px"
                  width="80px"
                  src="@/assets/images/elements/audio.png"
                />
              </div>
              <div v-else-if="details.file_type === 'application/pdf'">
                <img
                  class="cstm-card-img"
                  height="80px"
                  width="80px"
                  src="@/assets/images/elements/doc.png"
                />
              </div>
              <div slot="media" v-else>
                <img
                  class="cstm-card-img"
                  height="80px"
                  width="80px"
                  src="@/assets/images/elements/doc.png"
                />
              </div>
            </vs-col>
            <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center">
            <p>{{details.size}}</p>
          </vs-col> -->
          </vs-row>

          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <h6>Information</h6>
              <br />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>Type</p>
              <br />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>{{ details.file_type }}</p>
              <br />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>Size</p>
              <br />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>{{ details.size / 1000 }}</p>
              <span>KB</span><br />
            </vs-col> </vs-row
          ><vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>Location</p>
              <br />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>{{ testrepoPathCopy }}</p>
              <br />
            </vs-col> </vs-row
          ><vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>Created By</p>
              <br />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>{{ name.first_name }} {{ name.last_name }}</p>
              <br />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>Updated By</p>
              <br />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>{{ name.first_name }} {{ name.last_name }}</p>
              <br />
            </vs-col>
          </vs-row>
        </div>
        <div v-if="sharingTab === true">
          <vs-divider border-style="dotted" color="dark"></vs-divider>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <h6>Settings</h6>
              <br />
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <p>File Sharing</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="5.5"
            >
              <vs-switch v-model="switch1" />
            </vs-col>
          </vs-row>
          <vs-divider border-style="dotted" color="dark"></vs-divider>
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="flex-start"
              vs-w="2.5"
            >
              <vs-radio
                v-model="sharingOptions"
                vs-name="users"
                vs-value="users"
                >Users</vs-radio
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="flex-start"
              vs-w="2.5"
            >
              <vs-radio
                v-model="sharingOptions"
                vs-name="roles"
                vs-value="roles"
                >Roles</vs-radio
              >
            </vs-col>
            <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2.5">
           
            <vs-radio v-model="sharingOptions" vs-name="courses" vs-value="courses">Courses</vs-radio>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start" vs-w="2.5">
            
           <vs-radio v-model="sharingOptions" vs-name="all" vs-value="all">All</vs-radio>
          </vs-col> --> </vs-row
          ><br />
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="flex-start">
              <p v-if="sharingOptions === 'users'">
                The file will be available only to users whose name you specify
                below
              </p>
              <p v-if="sharingOptions === 'roles'">
                The file will be available only to users of the roles that you
                select below
              </p>
              <!-- <p v-if="sharingOptions==='courses'">The file will be available only to users of the courses that you select below</p>
          <p v-if="sharingOptions==='all'">The file will be available to all</p> -->
            </vs-col> </vs-row
          ><br />

          <vs-row v-if="sharingOptions === 'users'">
            <shareUser />
          </vs-row>
          <vs-row v-if="sharingOptions === 'roles'">
            <select
              label="Role"
              v-model="user_roles_id"
              class="mt-5 select_custom"
              @change="fetch_list(user_roles_id)"
            >
              <option value disabled selected hidden>Choose Role</option>
              <option
                :key="index"
                :value="item.role_name"
                v-for="(item, index) in roleList"
              >
                {{ item.role_name }}
              </option>
            </select>

            <span v-if="selectedUsers.length != 0">
              <h6 class="mb-2">Users</h6>
              <div class="flex flex-wrap mb-4">
                <div
                  class="text-center mr-1"
                  v-for="(selectedUser, index16) in selectedUsers"
                  :key="index16"
                >
                  <div class="selected-names">
                    <img
                      v-if="selectedUser.picture != ''"
                      class="person-img rounded-full shadow-md block"
                      :src="selectedUser.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    <span @click="closeSelectedUser(index16)" class="close"
                      >&times;</span
                    >
                  </div>
                  <p class="name-selected">
                    {{ selectedUser.first_name }} {{ selectedUser.last_name }}
                  </p>
                </div>
              </div>
            </span>
            <vs-table
              multiple
              v-model="selectedUsers"
              :data="User_Role"
              v-if="user_roles_id != null"
            >
              <template slot="thead">
                <vs-th>Select all</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].picture">
                    <img
                      v-if="data[indextr].picture != ''"
                      class="person-img rounded-full shadow-md block"
                      :src="data[indextr].picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-row>
          <!-- <vs-row v-if="sharingOptions==='courses'">
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-checkbox v-model="courses" vs-value="courses">Course1</vs-checkbox>
              </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-checkbox v-model="courses" vs-value="courses1">Course2</vs-checkbox>
              </vs-col>
        </vs-row> -->
          <br /><br /><br /><br />
          <vs-row>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
              <vs-button @click="shareToUser">Share</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-popup>
    </vs-row>
  </vs-col>
</template>

<script>
import { role_list, fetch_users } from '@/api/user'
import shareUser from './shareComponent.vue'
import sidebar from '@/views/pages/files/index.vue'
import Search from '@/views/pages/files/Search.vue'
import createsubfolder from '@/views/pages/files/CreateSubFolder.vue'
import fileupload from '@/views/pages/files/FileUpload.vue'
import {
  repoDetails,
  fileDelete,
  repoDelete,
  multipleFileDelete,
  fileRename
} from '@/api/file.js'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import axios from 'axios'
export default {
  name: 'folders',
  components: {
    sidebar,
    Search,
    createsubfolder,
    fileupload,
    shareUser
  },
  mixins: [PermissionMiddleware],
  props: ['testrepo_id', 'testrepo_path', 'allFile', 'buttonHide'],
  data () {
    return {
      selectedUsers: [],
      user_roles_id: null,
      roleList: [],
      allFileCopy: {},
      testrepoPathCopy: '',
      testrepoIdCopy: '',
      buttonHideCopy: false,
      fileRenameDetails: {
        id: '',
        file_name: ''
      },
      courses: [],
      roles: [],
      users: [],
      sharingOptions: 'users',
      sharingTab: false,
      switch1: true,
      detailsTitle: '',
      details: '',
      popupDetails: false,
      popupEdit: false,
      buttonActive: false,
      checkBox1: [],
      files: [],
      deletedFile: null,
      removeAll: false,
      active: false,
      selectedFile: null,
      deletepopupflag: false,
      deletepopupflag1: false,
      deletepopupflag2: false,
      deleted_id: '',
      file_id: '',
      subfolderData: {
        repository_name: '',
        repository_path: '',
        parent_repository_id: ''
      },
      file1: [],
      file2: [],
      name: [],
      staffList: false,
      User_Role: []
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Files')
    }

    this.fetchRoleList()
  },
  mounted () {
    this.buttonHide = true
  },
  watch: {
    allFile () {
      this.allFileCopy = this.allFile
    },
    testrepo_path () {
      this.testrepoPathCopy = this.testrepo_path
    },
    testrepo_id () {
      this.testrepoIdCopy = this.testrepo_id
    },
    buttonHide () {
      this.buttonHideCopy = this.buttonHide
    }
  },
  methods: {
    shareToUser () {
      const arr = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        if ('user_type' in this.selectedUsers[i]) {
          // added for error resolve 13/01/2021
          arr.push({
            user_type: this.selectedUsers[i].user_type,
            users_id: this.selectedUsers[i].users_id
          })
        }
      }

      for (let i = 0; i < this.selectedClients.length; i++) {
        if ('user_type' in this.selectedClients[i]) {
          arr.push({
            user_type: this.selectedClients[i].user_type,
            users_id: this.selectedClients[i].client_users_id
          })
        }
      }
    },
    async fetch_list (role_name) {
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const userId = this.$store.state.LoginStorage.user_details.customer_id
      try {
        const { data } = await fetch_users(userId)
        const userList = data.data.operationalUser
        this.User_Role = userList.filter((ele) => {
          if (ele.roles === role_name) {
            return ele
          }
        })
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchRoleList () {
      try {
        const res = await role_list(this.$store.getters.customerId)

        this.roleList = res.data.data.role_list
      } catch (error) {}
    },
    detailsPopup (item) {
      this.popupDetails = true
      this.details = item
      this.name = JSON.parse(localStorage.getItem('userInfo'))
    },

    updateFileName () {
      if (this.fileRenameDetails.file_name !== '') {
        this.buttonActive = true
        fileRename(this.fileRenameDetails)
          .then((res) => {
            repoDetails(
              localStorage.getItem('customer_id'),
              this.testrepoIdCopy
            )
              .then((res) => {
                this.file1 = res.data.data.repository.files
                this.allFileCopy.file1 = this.file1
                this.popupEdit = false
                this.$vs.notify({
                  title: 'Success',
                  text: 'File name changed successfully',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })
              })
              .catch((e) => {
                this.popupEdit = false
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Something Went Wrong',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })
              })
          })
          .catch((e) => {
            this.popupEdit = false
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          })
      }
    },

    editPopup (item) {
      this.buttonActive = false
      this.popupEdit = true
      this.fileRenameDetails.id = item.files_id
      const index = item.file_name.lastIndexOf('.')
      const fileName = item.file_name.substring(0, index)
      this.fileRenameDetails.file_name = fileName
    },

    back () {
      repoDetails(localStorage.getItem('customer_id'), this.testrepoIdCopy)
        .then((res) => {
          this.allFileCopy = {
            file2: res.data.data.repository.sub_repository,
            file1: res.data.data.repository.files
          }
          this.testrepoPathCopy = res.data.data.repository.repository_path
          this.testrepoIdCopy = res.data.data.repository.repository_id

          repoDetails(
            localStorage.getItem('customer_id'),
            res.data.data.repository.parent_repository_id
          )
            .then((res) => {
              this.allFileCopy = {
                file2: res.data.data.repository.sub_repository,
                file1: res.data.data.repository.files
              }
              this.testrepoPathCopy = res.data.data.repository.repository_path
              this.testrepoIdCopy = res.data.data.repository.repository_id
              if (res.data.data.repository.parent_repository_id === 0) {
                this.buttonHideCopy = true
              }
            })
            .catch((e) => {})
        })
        .catch((e) => {})
    },
    fileDelete (id) {
      this.deletepopupflag1 = true
      this.file_id = id
    },
    fileDeleteConfirm () {
      fileDelete(this.file_id)
        .then((res) => {
          for (let i = 0; i < this.allFileCopy.file1.length; i++) {
            if (this.file_id == this.allFileCopy.file1[i].files_id) {
              this.allFileCopy.file1.splice(i, 1)
            }
          }
          this.$emit('staticCount')
          this.deletepopupflag1 = false
          this.$vs.notify({
            title: 'Success',
            text: 'File deleted successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })

          // repoDetails(localStorage.getItem('customer_id'), this.testrepoIdCopy)
          //   .then((res) => {
          //     this.file1 = res.data.data.repository.files
          //     this.allFileCopy.file1 = this.file1
          //     this.$emit('staticCount')
          //     this.deletepopupflag1 = false
          //     this.$vs.notify({
          //       title: 'Success',
          //       text: 'File deleted successfully',
          //       color: 'success',
          //       iconPack: 'feather',
          //       icon: 'icon-alert-circle'
          //     })
          //   })
          //   .catch((e) => {

          //     this.deletepopupflag1 = false
          //     this.$vs.notify({
          //       title: 'Warning',
          //       text: 'Something Went Wrong',
          //       color: 'warning',
          //       iconPack: 'feather',
          //       icon: 'icon-alert-circle'
          //     })
          //   })
        })
        .catch((e) => {
          this.deletepopupflag1 = false
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },

    folderDelete (id) {
      this.deletepopupflag = true
      this.deleted_id = id
    },
    folderDeleteConfirm () {
      repoDelete(localStorage.getItem('customer_id'), this.deleted_id)
        .then((res) => {
          for (let i = 0; i < this.allFileCopy.file2.length; i++) {
            if (this.deleted_id == this.allFileCopy.file2[i].repository_id) {
              this.allFileCopy.file2.splice(i, 1)
            }
          }
          const getData = this.allFileCopy.file2
          this.$emit('refetchedFol', getData)
          this.$emit('staticCount')
          this.deletepopupflag = false
          this.$vs.notify({
            title: 'Success',
            text: 'Folder deleted successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },
    addedSubFolder (fetchedData) {
      this.file2 = fetchedData
      this.allFileCopy.file2 = this.file2
      this.$emit('addedFol', this.allFileCopy.file2)
    },
    addedFile (fetchedData) {
      this.file1 = fetchedData.files
      this.allFileCopy.file1 = this.file1
      this.$emit('staticCount')
    },
    downloadImage (item) {
      //
      axios({
        url: `${item.file_path}`,
        method: 'GET',
        responseType: 'blob',
        headers: { 'Access-Control-Allow-Origin': '*' }
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    check (e) {
      if (e.target.checked) {
        this.files.push(e.target.value)
        this.deletedFile = {
          files: this.files
        }
        this.removeAll = true
      } else {
        this.files = this.files.filter((item) => {
          return item != e.target.value
        })
      }
    },
    allDelete () {
      this.deletepopupflag2 = true
    },
    allDeleteConfirm () {
      multipleFileDelete(this.deletedFile)
        .then((res) => {
          for (const sent_id of this.deletedFile.files) {
            for (let i = 0; i < this.allFileCopy.file1.length; i++) {
              if (sent_id == this.allFileCopy.file1[i].files_id) {
                this.allFileCopy.file1.splice(i, 1)
              }
            }
          }
          this.checkBox1 = []
          this.removeAll = false
          this.deletepopupflag2 = false
          this.$emit('staticCount')
          this.$vs.notify({
            title: 'Success',
            text: 'Files deleted successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          // repoDetails(localStorage.getItem('customer_id'), this.testrepoIdCopy)
          //   .then((res) => {
          //     this.file1 = res.data.data.repository.files
          //     this.allFileCopy.file1 = this.file1
          //     this.checkBox1 = []
          //     this.removeAll = false
          //     this.deletepopupflag2 = false
          //     this.$emit('staticCount', res.data.data.repository)
          //     this.$vs.notify({
          //       title: 'Success',
          //       text: 'Files deleted successfully',
          //       color: 'success',
          //       iconPack: 'feather',
          //       icon: 'icon-alert-circle'
          //     })
          //   })
          //   .catch((e) => {

          //     this.checkBox1 = []
          //     this.removeAll = false
          //     this.deletepopupflag2 = false
          //     this.$vs.notify({
          //       title: 'Warning',
          //       text: 'Something Went Wrong',
          //       color: 'warning',
          //       iconPack: 'feather',
          //       icon: 'icon-alert-circle'
          //     })
          //   })
        })
        .catch((e) => {
          this.checkBox1 = []
          this.removeAll = false
          this.deletepopupflag2 = false
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },
    openFolder (item) {
      this.buttonHideCopy = false
      // eslint-disable-next-line no-var
      var obj = {
        repository_id: item.repository_id,
        repository_path: item.repository_path
      }
      this.$store.commit('UPDATE_REPO', obj)
      this.testrepoIdCopy = this.$store.getters.repoId
      this.testrepoPathCopy = this.$store.getters.repoPath
      repoDetails(localStorage.getItem('customer_id'), this.testrepoIdCopy)
        .then((res) => {
          this.allFileCopy = {
            file2: res.data.data.repository.sub_repository,
            file1: res.data.data.repository.files
          }
        })
        .catch((e) => {})
    }
  }
}
</script>
<style lang="stylus">
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /* height: auto !important; */
  /* position: absolute; */
  /* top: 12%; */
}

// [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items {
// overflow-y: scroll;
// }
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.header-sidebar-style {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar-style {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-right: 1px solid rgba(0, 0, 0, 0.07) !important;
  }
}

.inputField {
  height: 44px;
  border: none;
  background-color: white;
  color: #787878;
  font-size: 12px;
  width: 100%;
  border-bottom: 2px dotted #cccccc;
}

.checkboxStyle {
  cursor: pointer;
  margin-top: 13px;
  margin-right: 18px;
}

.pStyle {
  cursor: pointer;
}

.cstm-cardx .vs-card--content {
  margin-bottom: 0;
}

.cstm-card-img {
  height: 100px;
  object-fit: cover;
}

.cstm-file-name {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 130px;
}
</style>